// extracted by mini-css-extract-plugin
export default {"button28":"MyButton_button28__yOqMi","icon":"MyButton_icon__ikal2"};